import script from "./IntegrationsTab.vue?vue&type=script&setup=true&lang=js"
export * from "./IntegrationsTab.vue?vue&type=script&setup=true&lang=js"

import "./IntegrationsTab.vue?vue&type=style&index=0&id=13b9b5b4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13b9b5b4"]])

export default __exports__